import { c as _c } from "react/compiler-runtime";
import { Badge } from '@onefootprint/ui';
import { cx } from 'class-variance-authority';
import type { ReactNode } from 'react';
type Choice = {
  id: string;
  name: string;
  description?: string;
  marker: ReactNode;
  added?: boolean;
  onSelect: () => void;
};
type ChoiceListProps = {
  choices: Choice[];
  addedLabel?: string;
};
const ChoiceRow = t0 => {
  const $ = _c(31);
  const {
    choice,
    addedLabel
  } = t0;
  const t1 = choice.added;
  const t2 = choice.description ? "items-start" : "items-center";
  const t3 = choice.added ? "cursor-default" : "cursor-pointer hover:bg-hover";
  let t4;
  if ($[0] !== t2 || $[1] !== t3) {
    t4 = cx("flex w-full gap-2.5 rounded-default border border-tertiary p-3 text-left outline-none transition-colors focus-visible:ring-1 focus-visible:ring-accent focus-visible:ring-inset", t2, t3);
    $[0] = t2;
    $[1] = t3;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  const t5 = choice.added ? undefined : choice.onSelect;
  const t6 = choice.description && "mt-0.5";
  const t7 = choice.added ? "text-quaternary" : "text-primary";
  let t8;
  if ($[3] !== t6 || $[4] !== t7) {
    t8 = cx("flex size-5 shrink-0 items-center justify-center", t6, t7);
    $[3] = t6;
    $[4] = t7;
    $[5] = t8;
  } else {
    t8 = $[5];
  }
  let t9;
  if ($[6] !== choice.marker || $[7] !== t8) {
    t9 = <span aria-hidden={true} className={t8}>{choice.marker}</span>;
    $[6] = choice.marker;
    $[7] = t8;
    $[8] = t9;
  } else {
    t9 = $[8];
  }
  const t10 = choice.added ? "text-tertiary" : "text-primary";
  let t11;
  if ($[9] !== t10) {
    t11 = cx("truncate text-label-3", t10);
    $[9] = t10;
    $[10] = t11;
  } else {
    t11 = $[10];
  }
  let t12;
  if ($[11] !== choice.name || $[12] !== t11) {
    t12 = <span className={t11}>{choice.name}</span>;
    $[11] = choice.name;
    $[12] = t11;
    $[13] = t12;
  } else {
    t12 = $[13];
  }
  let t13;
  if ($[14] !== addedLabel || $[15] !== choice.added) {
    t13 = choice.added && addedLabel && <Badge variant="neutral">{addedLabel}</Badge>;
    $[14] = addedLabel;
    $[15] = choice.added;
    $[16] = t13;
  } else {
    t13 = $[16];
  }
  let t14;
  if ($[17] !== t12 || $[18] !== t13) {
    t14 = <span className="flex items-center gap-2">{t12}{t13}</span>;
    $[17] = t12;
    $[18] = t13;
    $[19] = t14;
  } else {
    t14 = $[19];
  }
  let t15;
  if ($[20] !== choice.description) {
    t15 = choice.description && <span className="mt-0.5 line-clamp-2 text-body-3 text-tertiary">{choice.description}</span>;
    $[20] = choice.description;
    $[21] = t15;
  } else {
    t15 = $[21];
  }
  let t16;
  if ($[22] !== t14 || $[23] !== t15) {
    t16 = <span className="min-w-0 flex-1">{t14}{t15}</span>;
    $[22] = t14;
    $[23] = t15;
    $[24] = t16;
  } else {
    t16 = $[24];
  }
  let t17;
  if ($[25] !== choice.added || $[26] !== t16 || $[27] !== t4 || $[28] !== t5 || $[29] !== t9) {
    t17 = <li><button aria-disabled={t1} className={t4} onClick={t5} type="button">{t9}{t16}</button></li>;
    $[25] = choice.added;
    $[26] = t16;
    $[27] = t4;
    $[28] = t5;
    $[29] = t9;
    $[30] = t17;
  } else {
    t17 = $[30];
  }
  return t17;
};
const ChoiceList = t0 => {
  const $ = _c(7);
  const {
    choices,
    addedLabel
  } = t0;
  let t1;
  if ($[0] !== addedLabel || $[1] !== choices) {
    let t2;
    if ($[3] !== addedLabel) {
      t2 = choice => <ChoiceRow addedLabel={addedLabel} choice={choice} key={choice.id} />;
      $[3] = addedLabel;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    t1 = choices.map(t2);
    $[0] = addedLabel;
    $[1] = choices;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[5] !== t1) {
    t2 = <ul className="flex flex-col gap-2">{t1}</ul>;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};
export type { Choice };
export default ChoiceList;